export class DriverMaster {
  public DRIVER_ID!: number;
  public DRIVER_CODE!: string;
  public DRIVER_NAME!: string;
  public MOBILE_NO!: string;
  public DOJ!: string;
  public DL!: string;
  public LEDGER_NAME!: string;
  public DRIVER_LOC!: number;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: Date;
  public UPDATED_DATE!: Date;
  public IS_ACTIVE!: boolean;
}
